import { Fragment } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { eliminarUnidad } from '../../../actions/configuracion';

const EliminarUnidadModal = ({ show, unidad, onHide, onSuccess }) => {
    const dispatch = useDispatch();

    const onEliminar = async () => {
        const id = unidad?._id || '';
        if (!id) return;

        const ok = await dispatch(eliminarUnidad(id));
        if (!ok) return;

        if (typeof onSuccess === 'function') {
            await onSuccess();
        } else if (typeof onHide === 'function') {
            onHide();
        }
    };

    return (
        <Fragment>
            <Modal show={show} onHide={onHide} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Eliminar unidad</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="alert alert-warning mb-0">
                        ¿Seguro que deseas eliminar la unidad <b>{unidad?.nombre || ''}</b>?
                        <br />
                        Esta acción no se puede deshacer.
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={onHide}>
                        Cancelar
                    </button>

                    <button type="button" className="btn btn-danger" onClick={onEliminar}>
                        Eliminar
                    </button>
                </Modal.Footer>
            </Modal>
        </Fragment>
    );
};

export default EliminarUnidadModal;
